// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { barginBinQuickBuyStyles } from "@awc/App/Components/BargainBin/BarginBinQuickBuy";
import { FormInputWrapper } from "@awc/MobiusOverrides/FormField";
import buttonSystemStyle from "@awc/XDL/PreStyle/button";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { barginBinBoxStyle, xScreen } from "@awc/XDL/Utilities";
import color from "@awc/XDL/Utilities/color";
import { css } from "styled-components";

barginBinQuickBuyStyles.priceAndQtyWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
    `,
};

barginBinQuickBuyStyles.variantOptions = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        & > *:empty {
            display: none;
        }

        &&& ${FormInputWrapper} {
            margin-top: 3px;
        }

        ${xScreen("lte", "md")} {
            width: 100%;
            margin-bottom: 16px;

            > div:first-child {
                max-width: 75%;
            }
        }
    `,
};

barginBinQuickBuyStyles.lengthWrapper = {
    css: css`
        max-width: fit-content;
    `,
};

barginBinQuickBuyStyles.subTitle = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        margin-bottom: 8px;
        width: 100%;
    `,
};

barginBinQuickBuyStyles.title = {
    variant: "h2",
    color: "common.white",
    css: css`
        padding: 12px;
        margin: 0;
        background: ${color("primary")};
    `,
};

barginBinQuickBuyStyles.productInfoWrapper = {
    css: css`
        ${barginBinBoxStyle}
        display: flex;
        flex-wrap: wrap;
        column-gap: 48px;
        padding: 8px;
    `,
};
barginBinQuickBuyStyles.buyBtn = {
    ...buttonSystemStyle.tertiary,
};
barginBinQuickBuyStyles.productQuantityOrderedStyles = {
    wrapper: {
        css: css`
            max-width: 136px;
        `,
    },
    qtyLabel: {
        weight: fontConfig.weight.medium,
    },
};
barginBinQuickBuyStyles.unitOfMeasureSelect = {
    labelProps: {
        weight: fontConfig.weight.bold,
    },
};
